class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);
      if (!element) return;

      if (section.id === 'mini-cart') {
        // Preserve cart-rec-swiper elements keyed by parent tag to survive the
        // innerHTML swap without flickering. Keying by parent tag distinguishes
        // the empty-cart swiper (inside a <div>) from the non-empty one (inside
        // <cart-recommendations>), so transitions between states still re-render.
        const savedSwipers = new Map();
        element.querySelectorAll('cart-rec-swiper').forEach((swiper) => {
          savedSwipers.set(swiper.parentElement?.tagName, swiper);
        });

        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

        element.querySelectorAll('cart-rec-swiper').forEach((newSwiper) => {
          const saved = savedSwipers.get(newSwiper.parentElement?.tagName);
          if (saved) newSwiper.replaceWith(saved);
        });
      } else {
        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
